import _ from "lodash";
import { Observable, of, throwError } from "rxjs";

import { ArchiveResource, EntityType, MaskFieldCompleteResource, SynchroMediaUpdates } from "@skinsoft/types";
import { ArchiveMissingDescriptionLevelCreateError } from "./errors";
import { archiveRecordMask } from "@skinsoft/record-mask-configs";
import { archiveSelectors } from "@skinsoft/selectors";
import { ArchiveDataStore } from "@skinsoft/entity";
import { EntitySyncUpHandler } from "../../entity-sync-up-handler/entity-sync-up-handler";
import { ArchiveOfflineDataUpdateCacher } from "@skinsoft/offline";
import { getOnlyValuesFromMaskFields } from "@skinsoft/utils";


// @ts-ignore
export class ArchiveSyncUpHandler extends EntitySyncUpHandler<ArchiveResource, ArchiveResource> {
    
    public static getInstance() {
        if (!ArchiveSyncUpHandler.instance) {
            ArchiveSyncUpHandler.instance = new ArchiveSyncUpHandler()
        }

        return ArchiveSyncUpHandler.instance
    }

    public static install(Vue) {
        ArchiveSyncUpHandler.getInstance()
    }

    private static instance: ArchiveSyncUpHandler = null as any

    private constructor() {
        super(
            new ArchiveOfflineDataUpdateCacher(),
            ArchiveDataStore.getInstance(),
            EntityType.ARCHIVE
        )
    }

    getAndFormatModificationsBeforeMerge(localEntity: ArchiveResource): Observable<Partial<ArchiveResource>> {
        const res: Partial<ArchiveResource> = {}

        if(localEntity) {
            const masks: MaskFieldCompleteResource[] = archiveRecordMask.categories?.flatMap(category => category.maskFields ?? []) ?? []

            const values = getOnlyValuesFromMaskFields(
                localEntity,
                masks,
            )

            for(const [key, value] of Object.entries(values)) {
                _.set(
                    res,
                    key,
                    value
                )
            }


            // the associated medias are not in the mask, so we need to copy them (as it will not be done 
            // automatically)
            const associatedMedias = _.get(localEntity, "associatedMedias")
            if(associatedMedias) {
                _.set(
                    res,
                    "associatedMedias",
                    associatedMedias
                )
            }
        }

        return of(res)
    }

    createNewEntity(dataToCreate: SynchroMediaUpdates<ArchiveResource>): Observable<ArchiveResource> {
        const descriptionLevel = archiveSelectors.descriptionLevel(dataToCreate.body)

        if(descriptionLevel) {
            return (this.dataStore as ArchiveDataStore).createWithDescriptionLevel(descriptionLevel)
        } 
        return throwError(new ArchiveMissingDescriptionLevelCreateError())
    }

    getType(): EntityType {
        return EntityType.ARCHIVE
    }
}